export function isTFNValid(value) {
  const weights = {
    8: [10, 7, 8, 4, 6, 3, 5, 1],
    9: [10, 7, 8, 4, 6, 3, 5, 2, 1],
  };

  const val = sanitiseTFN(value);

  if (val === '11111111' || val === '111111111') {
    return false;
  }

  let sum = 0;
  weights[val.length].forEach((weight, index) => {
    sum += weight * val[index];
  });

  return (sum / 11) % 1 === 0;
}

function sanitiseTFN(value) {
  return (value || '').replace(/[^\d]/g, '');
}
